import { render, staticRenderFns } from "./AddAsf.vue?vue&type=template&id=1420a892&"
import script from "./AddAsf.vue?vue&type=script&lang=js&"
export * from "./AddAsf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports